import { Box, useTheme } from "@mui/material";
import SongNguInspection from "assets/print-templates/inspection_songngu.jpg";
import {
  InspectionOtherStandard,
  PrintColorInspect,
} from "commons/enum/inspection";
import { numberFormatAsString } from "commons/ultilities";
import { dateTimeDisplay, utcToLocal } from "commons/ultilities/date/dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { getLabelOfOthersStandard } from "pages/product";
import { useCallback, useMemo } from "react";
import { ElementToPrint } from "share-components/templates/print/element";
import { PreviewPrinting } from "share-components/templates/print/print-preview";
import {
  createApprovalStandard,
  createHeightStandard,
  createLengthStandard,
  createPaperTypeInspectText,
  createPaperTypeStandard,
  createPrintColorStandard,
  createThicknessStandard,
  createWeightStandard,
  createWidthStandard,
  getLabelOfConclusionStatus,
  getLabelOfPrintColorInspection,
  getLabelOfStorageTemperature,
} from "../share";
import { RenderLabelWithoutBoldParentheses } from "../share/render-label-with-bold-parentheses";
const fontWeight = 600;
export const DualLangInspectionNotePrintPreview = observer(() => {
  const {
    dualLangInspectionNoteManagement: {
      dualLangInspectionPrintingManagement: {
        open: openPrint,
        setProp: setPrintManagementProp,
      },
      dualLangInspectionNoteDetail,
    },
  } = useStores();
  const onCloseHandler = useCallback(() => {
    setPrintManagementProp("open", false);
  }, [setPrintManagementProp]);
  const theme = useTheme();

  const dualLangInspectionElm = useMemo(() => {
    const inspectionDate = dualLangInspectionNoteDetail?.inspectionDate
      ? utcToLocal(dualLangInspectionNoteDetail?.inspectionDate)
      : null;
    const qcPrefixNumber = inspectionDate
      ? `PKN${inspectionDate.year().toString().slice(-2)}/`
      : "";

    const Elms: ElementToPrint[] = [
      {
        name: "inspectionDate",
        value:
          dateTimeDisplay(dualLangInspectionNoteDetail?.inspectionDate) || "",
        left: "17.65cm",
        top: "4.25cm",
        width: "3cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "number",
        value: `${qcPrefixNumber} ${
          dualLangInspectionNoteDetail?.number || ""
        }`,
        left: "17.65cm",
        top: "5.25cm",
        width: "3cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "customerName",
        value: (dualLangInspectionNoteDetail?.workOrderPO?.customerDisplay?.name ?? dualLangInspectionNoteDetail?.workOrder?.customer?.name) || "",
        left: "5.2cm",
        top: "6.25cm",
        width: "14.5cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "manufacturingDate",
        value:
          dateTimeDisplay(dualLangInspectionNoteDetail?.workOrderPO?.date ?? dualLangInspectionNoteDetail?.workOrder?.date) || "",
        left: "5.2cm",
        top: "11.2cm",
        width: "6.1cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "workOrderNumber",
        value: (dualLangInspectionNoteDetail?.workOrderPO?.woNumber ?? dualLangInspectionNoteDetail?.workOrder?.woNumber) || "",
        left: "5.2cm",
        top: "12cm",
        width: "6.1cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "poDate",
        value:
          dateTimeDisplay(
            dualLangInspectionNoteDetail?.purchaseOrder?.poDate,
          ) || "",
        left: "5.2cm",
        top: "8.75cm",
        width: "6.1cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "poNumber",
        value: dualLangInspectionNoteDetail?.purchaseOrder?.poNumber || "",
        left: "5.2cm",
        top: "9.55cm",
        width: "6.1cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "poOrderQuantity",
        value:
          (dualLangInspectionNoteDetail?.orderQuantity &&
            numberFormatAsString(
              dualLangInspectionNoteDetail?.orderQuantity?.toString(),
            ) + " pcs") ||
          "",
        left: "5.2cm",
        top: "10.35cm",
        width: "6.1cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "expireDate",
        value: dualLangInspectionNoteDetail?.expireDateText || "",
        left: "15.4cm",
        top: "12cm",
        width: "5cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "deliveredQuantity",
        value:
          (dualLangInspectionNoteDetail?.deliveredQuantity &&
            numberFormatAsString(
              dualLangInspectionNoteDetail?.deliveredQuantity?.toString(),
            ) + " pcs") ||
          "",
        left: "15.4cm",
        top: "7.9cm",
        width: "5cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "packagesQuantity",
        // value:
        //   (dualLangInspectionNoteDetail?.packagesQuantity &&
        //     numberFormatAsString(
        //       dualLangInspectionNoteDetail?.packagesQuantity?.toString()
        //     ) + " thùng") ||
        //   "",
        value: dualLangInspectionNoteDetail?.packagesQuantity || "",
        left: "15.4cm",
        top: "8.75cm",
        width: "5cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "quantityPerPackage",
        value:
          (dualLangInspectionNoteDetail?.quantityPerPackage &&
            numberFormatAsString(
              dualLangInspectionNoteDetail?.quantityPerPackage?.toString(),
            ) + " pcs/thùng") ||
          "",
        left: "15.4cm",
        top: "9.55cm",
        width: "5cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "inspectionSamples",
        // value:
        //   (dualLangInspectionNoteDetail?.inspectionSamples &&
        //     numberFormatAsString(
        //       dualLangInspectionNoteDetail?.inspectionSamples?.toString()
        //     ) + " pcs") ||
        //   "",
        value: dualLangInspectionNoteDetail?.inspectionSamples || "",
        left: "15.4cm",
        top: "10.35cm",
        width: "5cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "storageTemperature",
        value: getLabelOfStorageTemperature(
          dualLangInspectionNoteDetail?.storageTemperature || "",
        ),
        left: "15.4cm",
        top: "11.2cm",
        width: "5cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "note",
        value: dualLangInspectionNoteDetail?.note?.toString() || "",
        left: "5.2cm",
        top: "25.75cm",
        width: "14.5cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "inspector",
        value: dualLangInspectionNoteDetail?.inspector?.toString() || "",
        left: "0.9cm",
        top: "28.2cm",
        width: "5.5cm",
        textAlight: "center",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
    ];

    return Elms;
  }, [
    dualLangInspectionNoteDetail?.deliveredQuantity,
    dualLangInspectionNoteDetail?.expireDateText,
    dualLangInspectionNoteDetail?.inspectionDate,
    dualLangInspectionNoteDetail?.inspectionSamples,
    dualLangInspectionNoteDetail?.inspector,
    dualLangInspectionNoteDetail?.note,
    dualLangInspectionNoteDetail?.number,
    dualLangInspectionNoteDetail?.orderQuantity,
    dualLangInspectionNoteDetail?.packagesQuantity,
    dualLangInspectionNoteDetail?.purchaseOrder?.poDate,
    dualLangInspectionNoteDetail?.purchaseOrder?.poNumber,
    dualLangInspectionNoteDetail?.quantityPerPackage,
    dualLangInspectionNoteDetail?.storageTemperature,
    dualLangInspectionNoteDetail?.workOrder?.customer?.name,
    dualLangInspectionNoteDetail?.workOrder?.date,
    dualLangInspectionNoteDetail?.workOrder?.woNumber,
    dualLangInspectionNoteDetail?.workOrderPO?.customerDisplay?.name,
    dualLangInspectionNoteDetail?.workOrderPO?.date,
    dualLangInspectionNoteDetail?.workOrderPO?.woNumber,
  ]);

  const otherStandardSelect = useMemo(() => {
    const label = getLabelOfOthersStandard(
      dualLangInspectionNoteDetail?.product?.dimensionWeight
        ?.otherStandardSelect as InspectionOtherStandard,
    );
    if (label === InspectionOtherStandard.None) return "";
    return label;
  }, [
    dualLangInspectionNoteDetail?.product?.dimensionWeight?.otherStandardSelect,
  ]);

  const otherStandardStandardCombine = useMemo(() => {
    return (
      otherStandardSelect +
      (dualLangInspectionNoteDetail?.product?.dimensionWeight
        ?.otherStandardText || "")
    );
  }, [
    dualLangInspectionNoteDetail?.product?.dimensionWeight?.otherStandardText,
    otherStandardSelect,
  ]);

  const dualLangInspectionItemElms = useMemo(() => {
    if (!dualLangInspectionNoteDetail?.items) {
      return [];
    }
    const firstItem = dualLangInspectionNoteDetail?.items?.[0];
    const itemsElm: ElementToPrint[] = [
      {
        name: "productName",
        value: firstItem?.product?.name || "",
        left: "5.2cm",
        top: "7.05cm",
        width: "14.5cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "productCode",
        value: firstItem?.product?.code || "",
        left: "5.2cm",
        top: "7.9cm",
        width: "6.1cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      //Paper type
      {
        name: "paperType",
        value:
          (firstItem?.product && createPaperTypeStandard(firstItem?.product)) ||
          "",
        left: "6.2cm",
        top: "14.1cm",
        width: "7.6cm",
        textWrap: "nowrap",
      },
      {
        name: "paperTypeInspect",
        value:
          firstItem?.product && firstItem?.paperTypeInspect
            ? createPaperTypeInspectText(
                firstItem?.product,
                numberFormatAsString(
                  firstItem?.paperTypeInspect?.toString() || "",
                ),
              )
            : numberFormatAsString(
                firstItem?.paperTypeInspect?.toString() || "",
              ) || "",
        left: "13.9cm",
        top: "14.1cm",
        width: "3.7cm",
        textWrap: "nowrap",
        textAlight: "center",
        fontWeight: fontWeight,
      },
      {
        name: "paperTypeResult",
        value: firstItem.paperTypeResult
          ? RenderLabelWithoutBoldParentheses(
              getLabelOfConclusionStatus(firstItem.paperTypeResult),
            )
          : "",
        left: "17.65cm",
        top: "14.1cm",
        width: "2.2cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      //thinkness
      {
        name: "thinkness",
        value:
          (firstItem?.product && createThicknessStandard(firstItem?.product)) ||
          "",
        left: "6.2cm",
        top: "14.75cm",
        width: "7.6cm",
        textWrap: "nowrap",
      },
      {
        name: "thicknessInspect",
        value: firstItem.thicknessInspect
          ? numberFormatAsString(firstItem.thicknessInspect?.toString()) + "mm"
          : "",
        left: "13.9cm",
        top: "14.75cm",
        width: "3.7cm",
        textWrap: "nowrap",
        textAlight: "center",
        fontWeight: fontWeight,
      },
      {
        name: "thicknessResult",
        value: firstItem.thicknessResult
          ? RenderLabelWithoutBoldParentheses(
              getLabelOfConclusionStatus(firstItem.thicknessResult),
            )
          : "",
        left: "17.65cm",
        top: "14.75cm",
        width: "2.2cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      //weight
      {
        name: "weight",
        value:
          (firstItem.product && createWeightStandard(firstItem.product)) || "",
        left: "6.2cm",
        top: "15.4cm",
        width: "7.6cm",
        textWrap: "nowrap",
      },
      {
        name: "weightInspect",
        value: firstItem.weightInspect
          ? numberFormatAsString(firstItem.weightInspect?.toString()) + "gram"
          : "",
        left: "13.9cm",
        top: "15.4cm",
        width: "3.7cm",
        textWrap: "nowrap",
        textAlight: "center",
        fontWeight: fontWeight,
      },
      {
        name: "weightResult",
        value: RenderLabelWithoutBoldParentheses(
          getLabelOfConclusionStatus(firstItem.weightResult),
        ),
        left: "17.65cm",
        top: "15.4cm",
        width: "2.2cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      //length
      {
        name: "length",
        value:
          (firstItem.product && createLengthStandard(firstItem.product)) || "",
        left: "6.2cm",
        top: "16.35cm",
        width: "7.6cm",
        textWrap: "nowrap",
      },
      {
        name: "lengthInspect",
        value: firstItem.lengthInspect
          ? numberFormatAsString(firstItem.lengthInspect?.toString()) + "mm"
          : "",
        left: "13.9cm",
        top: "16.35cm",
        width: "3.7cm",
        textWrap: "nowrap",
        textAlight: "center",
        fontWeight: fontWeight,
      },
      {
        name: "lengthResult",
        value: RenderLabelWithoutBoldParentheses(
          getLabelOfConclusionStatus(firstItem.lengthResult),
        ),
        left: "17.65cm",
        top: "16.35cm",
        width: "2.2cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      //width
      {
        name: "width",
        value:
          (firstItem.product && createWidthStandard(firstItem.product)) || "",
        left: "6.2cm",
        top: "17cm",
        width: "7.6cm",
        textWrap: "nowrap",
      },
      {
        name: "widthInspect",
        value: firstItem.widthInspect
          ? numberFormatAsString(firstItem.widthInspect?.toString()) + "mm"
          : "",
        left: "13.9cm",
        top: "17cm",
        width: "3.7cm",
        textWrap: "nowrap",
        textAlight: "center",
        fontWeight: fontWeight,
      },
      {
        name: "widthResult",
        value: RenderLabelWithoutBoldParentheses(
          getLabelOfConclusionStatus(firstItem.widthResult),
        ),
        left: "17.65cm",
        top: "17cm",
        width: "2.2cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      //height
      {
        name: "height",
        value:
          (firstItem.product && createHeightStandard(firstItem.product)) || "",
        left: "6.2cm",
        top: "17.7cm",
        width: "7.6cm",
        textWrap: "nowrap",
      },
      {
        name: "heightInspect",
        value: firstItem.heightInspect
          ? numberFormatAsString(firstItem.heightInspect?.toString()) + "mm"
          : "",
        left: "13.9cm",
        top: "17.7cm",
        width: "3.7cm",
        textWrap: "nowrap",
        textAlight: "center",
        fontWeight: fontWeight,
      },
      {
        name: "heightResult",
        value: RenderLabelWithoutBoldParentheses(
          getLabelOfConclusionStatus(firstItem.heightResult),
        ),
        left: "17.65cm",
        top: "17.7cm",
        width: "2.2cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      //approval
      {
        name: "approval",
        value:
          (firstItem?.product && createApprovalStandard(firstItem?.product)) ||
          "",
        left: "6.2cm",
        top: "18.65cm",
        width: "7.6cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "approvalInspect",
        value: firstItem.approvalInspect
          ? RenderLabelWithoutBoldParentheses(firstItem.approvalInspect || "")
          : "",
        left: "13.9cm",
        top: "18.65cm",
        width: "3.7cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      {
        name: "approvalResult",
        value: RenderLabelWithoutBoldParentheses(
          getLabelOfConclusionStatus(firstItem.approvalResult),
        ),
        left: "17.65cm",
        top: "18.65cm",
        width: "2.2cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      //printColor
      {
        name: "printColor",
        value:
          (firstItem?.product &&
            createPrintColorStandard(firstItem?.product)) ||
          "",
        left: "6.2cm",
        top: "19.3cm",
        width: "7.6cm",
        textWrap: "nowrap",
        fontWeight: fontWeight,
      },
      {
        name: "printColorInspect",
        value:
          (firstItem.printColorInspect &&
            RenderLabelWithoutBoldParentheses(
              getLabelOfPrintColorInspection(
                firstItem.printColorInspect as PrintColorInspect,
              ),
            )) ||
          "",
        left: "13.9cm",
        top: "19.3cm",
        width: "3.7cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      {
        name: "printColorResult",
        value: RenderLabelWithoutBoldParentheses(
          getLabelOfConclusionStatus(firstItem.printColorResult),
        ),
        left: "17.65cm",
        top: "19.3cm",
        width: "2.2cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      //appearance
      {
        name: "appearance",
        value:
          (firstItem.appearanceInspectionStandard &&
            RenderLabelWithoutBoldParentheses(
              firstItem.appearanceInspectionStandard,
            )) ||
          "",
        left: "6.2cm",
        top: "19.85cm",
        width: "7.6cm",
        textWrap: "wrap",
        height: "2.3cm",
        lineHeight: "17px",
      },
      {
        name: "appearanceInspect",
        value: firstItem?.appearanceInspect
          ? RenderLabelWithoutBoldParentheses(
              firstItem?.appearanceInspect || "",
              // { breakLine: true },
            )
          : "",
        left: "13.9cm",
        top: "19.85cm",
        width: "3.7cm",
        textWrap: "wrap",
        textAlight: "center",
        height: "2.3cm",
      },
      {
        name: "appearanceResult",
        value: RenderLabelWithoutBoldParentheses(
          getLabelOfConclusionStatus(firstItem.appearanceResult),
        ),
        left: "17.65cm",
        top: "19.85cm",
        width: "2.2cm",
        textWrap: "nowrap",
        textAlight: "center",
        height: "2.3cm",
      },
      //otherStandard
      {
        name: "otherStandard",
        value: firstItem.product?.dimensionWeight && (
          <OtherStandard
            otherStandardStandard={otherStandardSelect}
            dimensionWeightOtherStandardText={
              firstItem.product?.dimensionWeight.otherStandardText || ""
            }
          ></OtherStandard>
        ),
        left: "6.2cm",
        top: "22.25cm",
        width: "7.6cm",
        height: "2.2cm",
        textWrap: "wrap",
        lineHeight: "18px",
      },
      {
        name: "otherStandardInspect",
        value: !otherStandardStandardCombine
          ? ""
          : firstItem.otherStandardInspect
            ? RenderLabelWithoutBoldParentheses(
                firstItem.otherStandardInspect || "",
              )
            : "",
        left: "13.9cm",
        top: "22.25cm",
        width: "3.7cm",
        height: "2.2cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      {
        name: "otherStandardResult",
        value: !otherStandardStandardCombine
          ? ""
          : RenderLabelWithoutBoldParentheses(
              getLabelOfConclusionStatus(firstItem.otherStandardResult),
            ),
        left: "17.65cm",
        top: "22.25cm",
        width: "2.2cm",
        textWrap: "nowrap",
        textAlight: "center",
        height: "2.2cm",
      },
      {
        name: "conclusion",
        value: RenderLabelWithoutBoldParentheses(firstItem.conclusion || ""),
        textWrap: "wrap",
        left: "6.2cm",
        top: "24.55cm",
        width: "13.6cm",
        height: "1.1cm",
        lineHeight: "18px",
      },
    ];

    return itemsElm;
  }, [
    dualLangInspectionNoteDetail?.items,
    otherStandardSelect,
    otherStandardStandardCombine,
  ]);

  const dualLangInpectionElements = useMemo(() => {
    return [...dualLangInspectionElm, ...dualLangInspectionItemElms];
  }, [dualLangInspectionElm, dualLangInspectionItemElms]);

  return (
    <PreviewPrinting
      open={openPrint}
      printIncludeTemplate={true}
      elements={dualLangInpectionElements}
      templateImage={SongNguInspection}
      backgroundSize="100%"
      backgroundPosition={"inherit"}
      mode="portrait"
      fontSize="14px"
      paperSize={{
        width: "21cm",
        height: "29.7cm",
      }}
      sx={{
        fontFamily: `"Times New Roman", Times, ${theme.typography.fontFamily} !important`,
      }}
      onClose={onCloseHandler}
    />
  );
});

const OtherStandard = ({
  dimensionWeightOtherStandardText,
  otherStandardStandard,
}: {
  otherStandardStandard: string;
  dimensionWeightOtherStandardText: string;
}) => {
  return (
    <Box
      component={"p"}
      sx={{
        whiteSpace: "pre-wrap",
      }}
    >
      {RenderLabelWithoutBoldParentheses(otherStandardStandard)}
      {dimensionWeightOtherStandardText &&
        ` ${dimensionWeightOtherStandardText || ""}`}
    </Box>
  );
};
